export default {
  meta: {
    title: '预估客流',
    url: '/predictflow', // 埋点字段，上报归属的模块
    urlName: '预估客流' // 埋点字段，上报归属的模块
  }
};
